<template lang="pug">
  ul.pagination
    li.pagination__prev
      a(href="")
    li.pagination__current
      a(href="") 1
    li
      a(href="") 2
    li
      a(href="") 3
    li
      a(href="") 4
    li
      a(href="") 5
    li.pagination__empty
      a(href="") ...
    li
      a(href="") 10
    li.pagination__next
      a(href="")
</template>

<script>
export default {
  name: "admin-table-pagination",
};
</script>
